var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.93237 8.48994C1.86616 8.33506 1.83203 8.16838 1.83203 7.99994C1.83203 7.83151 1.86616 7.66482 1.93237 7.50994C2.47103 6.22994 3.33237 5.15328 4.4097 4.41194C5.48703 3.67061 6.73503 3.29661 7.9997 3.33594C9.26437 3.29661 10.5117 3.67061 11.5897 4.41194C12.6677 5.15328 13.5284 6.22994 14.067 7.50994C14.1332 7.66482 14.1674 7.83151 14.1674 7.99994C14.1674 8.16838 14.1332 8.33506 14.067 8.48994C13.5284 9.76994 12.667 10.8466 11.5897 11.5879C10.5124 12.3293 9.26437 12.7033 7.9997 12.6639C6.73503 12.7033 5.4877 12.3293 4.4097 11.5879C3.3317 10.8466 2.47103 9.76994 1.93303 8.48994",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 10.3333C8.30577 10.3333 8.60918 10.2729 8.89228 10.1557C9.17537 10.0384 9.43259 9.86655 9.64926 9.64988C9.86593 9.43321 10.0378 9.17598 10.1551 8.89289C10.2723 8.60979 10.3327 8.30638 10.3327 7.99996C10.3327 7.69354 10.2723 7.39012 10.1551 7.10703C10.0378 6.82394 9.86593 6.56671 9.64926 6.35004C9.43259 6.13337 9.17537 5.9615 8.89228 5.84424C8.60918 5.72698 8.30577 5.66663 7.99935 5.66663C7.38051 5.66663 6.78702 5.91246 6.34943 6.35004C5.91185 6.78763 5.66602 7.38112 5.66602 7.99996C5.66602 8.6188 5.91185 9.21229 6.34943 9.64988C6.78702 10.0875 7.38051 10.3333 7.99935 10.3333Z",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.c1e752df9e7245a3534361b36e81f3d7.svg";
export { ForwardRef as ReactComponent };